// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://hillsboroughcountytaxcollector-vendor.aclarian.com',
  appName: 'Hillsborough County Tax Collector  | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub050a236235fc8f3d62d1c1ffc7e436c4',
  datadogApplicationId: 'ee584372-f37b-4978-a781-cd258814b5f1',
  datadogService: 'invoicing_hctc_prod',
  ApiKey: 'Mw8@KNG%yF34Xp#J',
  env: 'PROD',
  version: packageInfo.version,
};
